import { Chip } from '@heroui/react'

import type { ChipStyle } from './pos-format'

/**
 * The status chip every POS and Reports table uses.
 *
 * HeroUI's soft `Chip`, which is what Orders, Products, Discounts, Business,
 * Storefront, Modifiers and Tables all paint a status with. This used to be a
 * hand-rolled dot-and-label pill, and the result was that a drawer's "Open" and
 * an order's "New" — the same kind of statement, one screen apart — looked like
 * two different sorts of thing.
 *
 * The wrapper stays rather than calling `Chip` directly at each table, because
 * the useful part was never the paint: it is that the LABEL and the SEVERITY
 * both come from one place. Five tables deciding for themselves what to call a
 * force-closed session is how "Force-closed" and "Forced" end up a column apart.
 */
export function StatusChip({ style }: { style: ChipStyle }) {
  return (
    <Chip size="sm" variant="soft" color={style.tone}>
      {style.label}
    </Chip>
  )
}
